import { createBloxApp } from '@bagelink/blox'
import { createApi } from '@shared/api'
import App from './App.vue'
import { bloxSite } from './blox.config'
import router from './router'

import '@bagelink/vue/styles/core.css'
import '@bagelink/blox/style.css'
import './styles/theme.css'

createBloxApp({
	...bloxSite,
	rootComponent: App,
	router,
	navigation: 'document',
	// Self-hosted Plausible analytics — site id matches the deployed domain and
	// the blox_website.integrations.plausible_site_id set on the backend.
	plausible: 'shalvadinnerforchampions.com',
	createApi: ({ baseURL }) => {
		createApi({ baseURL })
	},
})
